export const referenceAsls = {
	"301": "Demo Center Primary",
	"203": "InnovaCorp",
	"204": "NextGen Systems",
	"205": "FutureTech Industries",
	"206": "Visionary Labs",
	"207": "QuantumSoft",
	"208": "BlueWave Technologies",
	"209": "Skyline Innovations",
	"210": "Pioneer Digital",
	"211": "Elite Systems",
	"212": "CoreLogic Enterprises",
	"213": "Vertex Solutions",
}

export const sexReferences = {
	"Maschio": "Maschio",
	"Femmina": "Femmina",
}

export const spAslCode = {
	"SP_301": "Demo Center Primary",
	"SP_203": "InnovaCorp",
	"SP_204": "NextGen Systems",
	"SP_205": "FutureTech Industries",
	"SP_206": "Visionary Labs",
	"SP_207": "QuantumSoft",
	"SP_208": "BlueWave Technologies",
	"SP_209": "Skyline Innovations",
	"SP_210": "Pioneer Digital",
	"SP_211": "Elite Systems",
	"SP_212": "CoreLogic Enterprises",
	"SP_213": "Vertex Solutions",
	"ICT": "ICT - Programmatori",
}


export const spAslCodeWithColor = {
	"SP_301": {label: "ASL Città di Torino", color: "rgba(255, 99, 132, 1)", transparentCol: "rgba(255, 99, 132, 0.3)"},
	"SP_203": {label: "ASL Torino 3", color: "rgba(54, 162, 235, 1)", transparentCol: "rgba(54, 162, 235, 0.3)"},
	"SP_204": {label: "ASL Torino 4", color: "rgba(255, 206, 86, 1)", transparentCol: "rgba(255, 206, 86, 0.3)"},
	"SP_205": {label: "ASL Torino 5", color: "rgba(75, 192, 192, 1)", transparentCol: "rgba(75, 192, 192, 0.3)"},
	"SP_206": {label: "ASL Vercelli", color: "rgba(153, 102, 255, 1)", transparentCol: "rgba(153, 102, 255, 0.3)"},
	"SP_207": {label: "ASL Biella", color: "rgba(255, 159, 64, 1)", transparentCol: "rgba(255, 159, 64, 0.3)"},
	"SP_208": {label: "ASL Novara", color: "rgb(215,195,59)", transparentCol: "rgb(215,195,50, 0.3)"},
	"SP_209": {label: "ASL Verbano-Cusio-Ossola", color: "rgb(143,180,154)", transparentCol: "rgb(143,180,150, 0.3)"},
	"SP_210": {label: "ASL Cuneo 1", color: "rgb(255,0,0)", transparentCol: "rgb(255,0,0, 0.3)"},
	"SP_211": {label: "ASL Cuneo 2", color: "rgb(60,11,103)", transparentCol: "rgb(60,11,100, 0.3)"},
	"SP_212": {label: "ASL Asti", color: "rgb(164,78,60)", transparentCol: "rgb(164,78,60, 0.3)"},
	"SP_213": {label: "ASL Alessandria", color: "rgb(78,211,151)", transparentCol: "rgb(78,211,150, 0.3)"},
	"ICT": {label: "ICT - Programmatori", color: "rgb(128,255,64)", transparentCol: "rgb(128,255,60, 0.3)"},
	"CIT": {label: "Cittadino", color: "rgb(252,135,39)", transparentCol: "rgba(252,135,39, 0.3)"},
}

export const relations = {
	"madre": "figlio-a",
	"padre": "figlio-a",

	"suocero": "nuora-genero",
	"suocera": "nuora-genero",

	"moglie": "marito",
	"marito": "moglie",

	"compagna": "compagno",
	"compagno": "compagna",

	"figlia": "genitore",
	"figlio": "genitore",

	"sorella": "fratello/sorella",
	"fratello": "fratello/sorella",

	"cugino": "cugino-a",
	"cugina": "cugino-a",

	"nipote": "nonno-a",

	"nonno": "nipote",
	"nonna": "nipote",

	"nuora": "suocero-a",
	"genero": "suocero-a",

	"cognato": "cognato-a",
	"cognata": "cognato-a",

	"coinquilino": "coinquilino-a",
	"coinquilina": "coinquilino-a",

	"badante": "assistito-a",
	"baby sitter": "assistito-a",
	"assistito": "badante",
	"assistita": "badante",

	"amico": "amico-a",
	"amica": "amico-a",

	"amante": "amante",
	"collega di lavoro": "collega di lavoro",
	"datore di lavoro": "dipendente",
	"dipendente": "datore di lavoro",

	//zio zia
}
